/**
 * Eversports widget ID registry.
 *
 * Migration: old iframe widgets (single studio ID `t4ez9i` with URL params)
 * → new loader.js widgets (one ID per view).
 *
 * Verify each widget's configuration in Eversports Manager
 * (Settings → Widgets [NEW]) matches the intended view before going live.
 */
export const EVERSPORTS_IDS = {
  // Homepage: today's courses (compact day view)
  // OLD: t4ez9i/day-event-calendar
  // NEW: "Stundenplan Klein" in Eversports Manager
  DAY_CALENDAR_HOME: "ff652185-b5a6-4d40-9e91-42405f55dbdc",

  // Homepage: full week schedule overview
  // OLD: t4ez9i (default week view)
  // NEW: "Widget" (Stundenplan) in Eversports Manager
  WEEK_SCHEDULE_HOME: "bbdeba07-7d56-4729-a225-28f4a560c982",

  // /course-booking page: bookable course schedule (Kursplan)
  // OLD: t4ez9i (default week view)
  // NEW: same as WEEK_SCHEDULE_HOME — reuse the same ID,
  //      OR create a dedicated widget if the studio wants a different view
  COURSE_BOOKING: "bbdeba07-7d56-4729-a225-28f4a560c982", // can be the same value as WEEK_SCHEDULE_HOME

  // /workshops page: workshops listing
  // OLD: t4ez9i?list=workshop
  // NEW: "Von Eversports erstellt: Aktivitäten" — VERIFY it filters to workshops only
  WORKSHOPS: "2684321e-90fe-4c6c-927f-bc57dec87b06",

  // /price-cards page: class passes / Kurskarten (NOT coupons — old title was misleading)
  // OLD: t4ez9i?list=shop
  // NEW: "Von Eversports erstellt: Preise" in Eversports Manager
  PRICE_CARDS: "e2326a9e-b74b-45cc-83cb-fdb4c43c07e2",

  // /coupons page: vouchers / Gutscheine
  // OLD: t4ez9i?list=voucher
  // NEW: "Gutscheine" (custom) in Eversports Manager
  VOUCHERS: "86c56e58-cb83-45f6-b187-e173ba1b4945",
} as const
